var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 337,
    viewBox: "0 0 572 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1809_71511)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 432,
    height: 197,
    fill: "#E7F0FF",
    fillOpacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1809_71511)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 115,
    width: 326,
    height: 195,
    rx: 9,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 181L254 198.5L253 199.308V226L279 243L304 226V198.5L279 181Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.5,
    cy: 213,
    rx: 12.5,
    ry: 12,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 195V170C296 164.477 300.477 160 306 160H347",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 268V228C351 222.477 346.523 218 341 218H304",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 195,
    transform: "translate(116 115)",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 124,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EA3626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 124,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EA3626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 124,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EA3626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 124,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EA3626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 124,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#EFBF42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 124,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#36D623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 138H338C343.523 138 348 142.477 348 148V184.5C348 190.023 352.477 194.5 358 194.5H400C405.523 194.5 410 198.977 410 204.5V235C410 240.523 405.523 245 400 245H397C391.477 245 387 249.477 387 255V256.5C387 262.023 382.523 266.5 377 266.5H358C352.477 266.5 348 270.977 348 276.5V285.5C348 291.023 343.523 295.5 338 295.5H279",
    stroke: "#E0E0E2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413,
    cy: 145,
    r: 3,
    fill: "#E0E0E2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 160,
    r: 3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 295,
    r: 3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 246,
    r: 3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351,
    cy: 269,
    r: 3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 247.5V256.5C394 262.023 398.477 266.5 404 266.5H446.433C449.618 266.5 452.613 264.982 454.497 262.414L457 259",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 318V297C375 291.477 379.477 287 385 287H450.5",
    stroke: "#E0E0E2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 114V135.5C381 141.023 385.477 145.5 391 145.5H456.5",
    stroke: "#E0E0E2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 254,
    width: 312,
    height: 98,
    fill: "url(#paint0_linear_1809_71511)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1809_71511",
    x: 0,
    y: 0,
    width: 572,
    height: 337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur_1809_71511"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1809_71511",
    x1: 286,
    y1: 254,
    x2: 286,
    y2: 344.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1809_71511"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 115,
    width: 326,
    height: 195,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiError);
export default __webpack_public_path__ + "static/media/ApiError.500ae2a7273c7dbdab22835d340132fb.svg";
export { ForwardRef as ReactComponent };